import { render, staticRenderFns } from "./CandidateSearchTable.vue?vue&type=template&id=55bc4076&scoped=true"
import script from "./CandidateSearchTable.vue?vue&type=script&lang=ts"
export * from "./CandidateSearchTable.vue?vue&type=script&lang=ts"
import style0 from "./CandidateSearchTable.vue?vue&type=style&index=0&id=55bc4076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc4076",
  null
  
)

export default component.exports